import { taskApiClient } from '@/utils/apiClient';

/**
 * Program service — proxied through the gateway to the task management backend
 */
export const provisionEnterprise = async (requestId: string) => {
  const res = await taskApiClient.post(`/programs/enterprise/${requestId}/provision`);
  return res.data;
};
